<template>
    <main>
        <div class="box">
            <div class="mark" @click="hideDownload"></div>
            <div class="content">
                <div class="close" @click="hideDownload"></div>
                <div class="middle" v-if="!success">
                    <div class="tit">我们将发送下载链接至您的邮箱</div>
                    <div class="input">
                        <input type="email" placeholder="请输入您的邮箱" v-model="email">
                    </div>
                    <div class="btn-box">
                        <div class="btn" @click="sendEmail">确认发送</div>
                    </div>
                </div>
                <div class="middle success" v-if="success">
                    <div class="tit">资料已发送至您的邮箱，请注意查收！</div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import {Toast} from "vant";

    export default {
        name: 'download-float',
        data() {
            return {
                success:false,
                email:"",
            }
        },
        props:{
            file:{
                type:Object,
                default:{}
            }
        },
        components:{

        },
        computed:{
            user_info(){
                return this.$store.state.user_info;
            }
        },
        methods: {
            sendEmail(){
                if(!this.email){
                    this.$toast.fail("请输入您的邮箱地址");return false;
                }
                if(!this.tool.type.checkStr(this.email,'email')){
                    this.$toast.fail("请输入正确的邮箱地址");return false;
                }
                // this.http.request({
                //     api:"file/sendFile",
                //     data:{
                //         email:this.email,
                //         file_id:this.file.file_id
                //     },
                //     loading:true,
                //     success:(res)=>{
                //         this.success = true;
                //         setTimeout(()=>{
                //             this.hideDownload();
                //         },3000)
                //     }
                // })
                this.$toast.loading({
                    mask:true,
                    duration:0
                });
                $.ajax({
                    method: 'POST',
                    url: "https://api.dellemc-solution.com/file/downloadWithEmail",
                    data:JSON.stringify({
                        email:this.email,
                        fileList:[this.file.file_id],
                        emailSubject:'2026戴尔科技峰会-相关资料下载',
                        senderEmail:'2022dtf@dell.com',
                        senderName:'2026戴尔科技峰会',
                        extra:{
                            tenantId:444
                        },
                        sess:this.$store.state.user_info.sess
                    }),
                    headers: {'Content-Type':'application/json'},
                    dataType: 'json',
                    success:(res)=>{
                        this.$toast.clear();
                        if(res.body.result == 0){
                            this.success = true;
                            setTimeout(()=>{
                                this.hideDownload();
                            },3000)
                        }else{
                            this.$toast.fail(res.body.desc);
                        }
                    },
                    error:(error)=>{
                        this.$toast.clear();
                        console.log(error);
                    }
                })
            },
            hideDownload(){
                this.$emit('hideDownload')
            }
        },
        mounted() {
            this.query = this.$route.query;
            if(this.user_info.id){
                this.email = this.user_info.email;
            }
        },
        destroyed() {
            this.hideDownload();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{width:750px;height:390px;background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;background-size: cover; position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);border-radius: 10px;
            .close{width: 50px;height:50px;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size: 20px;cursor: pointer;transition: background .3s ease;}
            .close:hover{background-image:url("~@/assets/image/53.png");background-size: 20px; transition: background .3s ease;}
            .middle{width:750px;height:390px;text-align: center;color: #fff;
                .tit{font-size:27px;}
                .input{height:50px;width: 440px;padding: 0 20px; margin: 20px auto 0;border: 1px solid #296abc;background: #10478a;
                    input{display: block;width: 100%;height:100%;background: none;border: none;color:#fff;font-size: 16px;text-align: center;}
                }
                .btn-box{margin-top: 30px;
                    .btn{width: 140px;height:50px;border-radius: 5px;margin: 0 auto; text-align: center;line-height: 50px;font-size: 16px;color:#fff;background:#2d75bc;transition: all .3s ease;cursor: pointer;}
                }
            }
        }
    }
</style>

